(ns hai.ui.components.new-design.girouette
  #?(:cljs (:require-macros hai.ui.components.new-design.girouette))
  (:require
   [lambdaisland.ornament :as o]
   [garden.selectors :as selectors :refer [defselector]])
  #?(:clj (:import (clojure.lang IFn))))

#?(:clj
   (o/set-tokens!
    {:components [{:id :full-center
                   :garden {:display "none"}}]}))


(defrecord SingleArgSelector [selector]
  selectors/ICSSSelector
  (css-selector [this]
    (selectors/css-selector (:selector this)))

  IFn
  (#?(:clj invoke
      :cljs -invoke)
    [this]
    this)

  (#?(:clj invoke
      :cljs -invoke)
    [this a]
    (selectors/selector
     (str (selectors/css-selector a)
          (selectors/css-selector this)))))

(defn ->pseudo-element
  [selector-name]
  (SingleArgSelector. (str "::" selector-name)))

(def before (->pseudo-element "before"))

#?(:clj
   (defmethod o/process-tag :circle
     [[_ {:keys [bounding-box-behaviour border-radius color size]
          :or {border-radius "50%"}}]]
     [:&
      {:display "flex"
       :justify-content "center"
       :align-items "center"
       :position "relative"}
      [(before :&)
       (case bounding-box-behaviour
         :contained {:position "relative"}
         :overflowing {:position "absolute"})
       {:content "''"
        :border-radius border-radius
        :width size
        :height size
        :background-color color}]
      [:>*
       (case bounding-box-behaviour
         :contained {:position "absolute"}
         :overflowing {:position "relative"})]]))
